import { render } from "./ImagesSlider.vue?vue&type=template&id=8a3a0a10&scoped=true"
import script from "./ImagesSlider.vue?vue&type=script&lang=js"
export * from "./ImagesSlider.vue?vue&type=script&lang=js"

import "./ImagesSlider.vue?vue&type=style&index=0&id=8a3a0a10&scoped=true&lang=scss"
import "./ImagesSlider.vue?vue&type=style&index=1&id=8a3a0a10&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8a3a0a10"]])

export default __exports__